import { render, staticRenderFns } from "./header.vue?vue&type=template&id=3725b809&scoped=true&"
import script from "./header.vue?vue&type=script&lang=ts&"
export * from "./header.vue?vue&type=script&lang=ts&"
import style0 from "./header.vue?vue&type=style&index=0&id=3725b809&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3725b809",
  null
  
)

export default component.exports